import React from 'react';
import { contact_info } from '../../constant.js';
// import { FaFacebook } from "react-icons/fa";
// import { AiFillInstagram } from "react-icons/ai";

const TopBar = () => {

    // const social_media = [
    //     {
    //         "title": "Facebook",
    //         "icon": <FaFacebook style={{ height: "18px", width: "18px" }} />,
    //         "link": "https://www.facebook.com",
    //         "color": "#3b5999"
    //     },
    //     {
    //         "title": "Instagram",
    //         "icon": <AiFillInstagram style={{ height: "20px", width: "20px" }} />,
    //         "link": "https://www.instagram.com",
    //         "color": "#C13584"
    //     },

    // ];
    return (
        <div className='d-flex justify-content-end oveflow-hidden w-100 gap-4' style={{ backgroundColor: "#2f244f", padding: "10px" }}>
            {
                contact_info.slice(0, 2).map((item, index) => (
                    <p style={{ fontSize: "16px", fontWeight: "400", color: "#fff", lineHeight: "20px", marginBottom: "0" }}><span>{item.icon}</span>&nbsp;&nbsp;{item.value}</p>
                ))
            }
            {/* <div className='d-flex gap-2'>
                {
                    social_media.map((item, index) => (
                        <a className='text-decoration-none text-light' href={item.link} target="_blank" rel="noopener noreferrer" >
                            <span className="icon text-light">{item.icon}</span></a>
                    ))
                }
            </div> */}
        </div>
    );
}

export default TopBar;